import { render, staticRenderFns } from "./PartTimePercentageTableRowComponent.vue?vue&type=template&id=2bbe857a&scoped=true"
import script from "./PartTimePercentageTableRowComponent.vue?vue&type=script&lang=js"
export * from "./PartTimePercentageTableRowComponent.vue?vue&type=script&lang=js"
import style0 from "./PartTimePercentageTableRowComponent.vue?vue&type=style&index=0&id=2bbe857a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbe857a",
  null
  
)

export default component.exports